<template>
  <div v-if="isVisible" class="alert action-alert fade" :class="[{show: isVisible}, `alert-${type}`]">
    <div class="d-flex">
      <div class="d-flex justify-content-center align-items-center">
        <font-awesome-icon :icon="icon || 'exclamation-circle'" style="font-size: 22px"></font-awesome-icon>
      </div>
      <div class="d-flex align-items-center mx-2">
        <slot>This is a test</slot>
      </div>
      <button class="close" @click="closeMethod()"><span>×</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionAlert',
  props: {
    icon: String,
    type: String,
    isVisible: Boolean,
    closeMethod: Function
  }
}
</script>

<style scoped>
.action-alert {
  position: fixed;
  top: 60px;
  right: 20px;
  min-width: 350px;
  z-index: 10;
}
.action-alert .close {
  margin-left: auto;
}
</style>
